import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';

import Icon from '../../../../Icon';
import styles from '../styles.styl';
import AudioLevel from './AudioLevel';
import SelectCustom from '../../../../SelectCustom';

function AudioSettings({
  otPublisher,
  devices = [],
  formatMessage,
  publisher,
}) {
  const [disabled, setDisabled] = useState(false);
  const hasAudio = true;
  const iconName = hasAudio ? 'mic' : 'sound-on-error';

  const getActiveAudioId = () => {
    try {
      return otPublisher.publisher.getAudioSource().getCapabilities().deviceId;
    } catch (e) {
      return '';
    }
  };

  const handleSelectAudioSource = useCallback(async deviceId => {
    setDisabled(true);
    try {
      await otPublisher.changeAudioSource(deviceId);
    } finally {
      setDisabled(false);
    }
  }, []);

  const audioDevices = devices.map(device => ({
    value: device.deviceId,
    label: device.label,
  }));

  return (
    <div className={styles.row}>
      <div className={cn(styles.row, 'mr1')}>
        <Icon name={iconName} size={32} className="mr1" />
        <div>
          <p className={cn(styles.text, 'mb1')}>
            {formatMessage({ id: 'virtualVisit.test.mic' })}
          </p>
          <AudioLevel publisher={get(publisher, 'entity')} />
        </div>
      </div>
      <SelectCustom
        disabled={disabled}
        value={getActiveAudioId()}
        options={audioDevices}
        needUpdateDefaultValue
        onChange={({ value }) => handleSelectAudioSource(value)}
        className={styles.select}
      />
    </div>
  );
}
AudioSettings.propTypes = {
  formatMessage: PropTypes.func,
  otPublisher: PropTypes.object.isRequired,
  publisher: PropTypes.object.isRequired,
  devices: PropTypes.array.isRequired,
};
export default AudioSettings;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaSettings/AudioSettings/index.jsx